import { FileOutlined } from '@ant-design/icons'
import { Checkbox, Empty } from 'antd'
import Spinner from 'components/Spinner/Spinner'
import moment from 'moment'
import React from 'react'

export default function FileSection({
    loading,
    files,
    selectedFiles,
    onFilesChange
}) {

    const allFilesChecked = files.every(address => {
        return selectedFiles?.includes(address.documentId)
    })
    console.log('selectedFiles', selectedFiles, allFilesChecked)

    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <FileOutlined />
                    <span style={{
                        fontWeight: 600,
                        fontFamily: 'tradeGothic',
                        fontSize: 14
                    }}>
                        Files
                    </span>
                </div>

                <div style={{ display: 'flex', gap: 8 }}>
                    <Checkbox
                        disabled={files.length < 1}
                        checked={allFilesChecked}
                        onChange={e => {
                            console.log('allFilesChecked', allFilesChecked)
                            if (allFilesChecked)
                                onFilesChange([])
                            else {
                                const documentIds = files.map(file => file.documentId)
                                console.log('documentIds', documentIds)
                                onFilesChange(documentIds)
                            }
                        }}

                    />
                    <span>Select All</span>
                </div>

            </div>
            {
                loading && <div style={{
                    display: 'flex', justifyContent: 'center',
                    alignItems: 'center', padding: 8
                }}> <Spinner /> </div>
            }
            {
                !files.length && !loading && <Empty
                    imageStyle={{ height: 32 }}
                    style={{ padding: 12, fontWeight: 500, fontSize: 14 }}
                    description="No Files Available"
                />
            }
            {
                files.map(file => {
                    const isChecked = selectedFiles.includes(file.documentId)
                    return <div style={{
                        padding: 8,
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <div style={{
                            display: 'flex', gap: 8
                        }}>
                            <Checkbox
                                checked={isChecked}
                                onChange={() => {
                                    if (isChecked) {
                                        const filteredFiles = selectedFiles.filter(selectedFileId => selectedFileId !== file.documentId)
                                        onFilesChange(filteredFiles)
                                    } else {
                                        onFilesChange([...selectedFiles, file.documentId])
                                    }
                                }}
                            />
                            <span style={{
                                fontFamily: 'tradeGothic',
                                fontSize: 14,

                            }}>
                                {file.documentName}
                            </span>
                        </div>
                        {
                            file.uploadDate &&
                            <span style={{
                                fontFamily: 'tradeGothic',
                                fontSize: 11,
                                color: '#737b8c'
                            }}>Uploaded on {moment(file.uploadDate).format("DD MMM YYYY")} </span>
                        }

                    </div>
                })
            }

        </div>
    )
}
